import { UploadData } from '../../../../store/uploadStore';
import { UploadValidationStatus } from '../../../../consts/uploadValidationStatus';
import { getUploadValidationStatus } from '../helpers/uploadValidation';

export const getGlobalValidationStatus = (currentUploads: UploadData[]) => {
  return currentUploads.reduce((acc: UploadValidationStatus | null, upload) => {
    const status = getUploadValidationStatus(upload);
    if (acc == UploadValidationStatus.HasErrors) {
      return acc;
    }
    if ([UploadValidationStatus.HasErrors, UploadValidationStatus.HasWarnings].includes(status)) {
      return status;
    }

    return acc;
  }, null);
};
